import { Suspense } from 'react';
import { Skeleton } from '@sara/ui/components/skeleton';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { InterviewBriefDetailContainerContent } from './InterviewBriefDetailContainerContent';
import type { InterviewBriefDetailContainerProps } from './types';

export type { InterviewBriefDetailContainerProps };

export function InterviewBriefDetailContainer(props: InterviewBriefDetailContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense
        fallback={
          <div className="space-y-6">
            <Skeleton className="h-20 w-full rounded-xl" />
            <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
              <Skeleton className="h-24 rounded-xl" />
              <Skeleton className="h-24 rounded-xl" />
              <Skeleton className="h-24 rounded-xl" />
              <Skeleton className="h-24 rounded-xl" />
            </div>
            <Skeleton className="h-64 w-full rounded-2xl" />
          </div>
        }
      >
        <InterviewBriefDetailContainerContent {...props} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
